import { render } from "./ItemForm.vue?vue&type=template&id=6588b3a4&scoped=true"
import script from "./ItemForm.vue?vue&type=script&lang=js"
export * from "./ItemForm.vue?vue&type=script&lang=js"

import "./ItemForm.vue?vue&type=style&index=0&id=6588b3a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6588b3a4"]])

export default __exports__